// Hooks
// Atoms
import { useAtomValue } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import H1 from '@/components/base/Headings/H1';
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
// Components
import { SelectPost } from '@/components/pages/giveaway-picker/SelectPostWrapper/components/SelectPost';

export function SelectPostWrapper() {
    const { t } = useTranslation('giveaway_picker');
    const currentStep = useAtomValue(currentStepAtom);
    if (currentStep !== 2) {
        return null;
    }

    return (
        <div className="@container" data-testid="select-post-wrapper">
            <H1 className="mb-14">{t('post_selection.select_winning_post')}</H1>
            <SelectPost />
        </div>
    );
}
